import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { getField, getGroupListData, getUserName } from '@core/_utils/tools.utils';
import { forkJoin, lastValueFrom, map } from 'rxjs';

@Component({
    selector: 'app-list-users',
    templateUrl: './list-users.component.html',
    styleUrls: ['./list-users.component.scss'],
})
export class ListUsersComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public dataList = [];
    public activeList = [];
    public userListDelegate = [];
    public groupListBase = [];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    public duplicate = false;

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Cf_Actif'), field: 'us_active' },
            { header: this.translate.instant('Cf_Wiz'), field: 'us_autogenerated' },
            { header: this.translate.instant('Cf_TypU'), field: 'us_usertype' },
            { header: this.translate.instant('Cf_Login'), field: 'name' },
            { header: this.translate.instant('Cf_LastName'), field: 'us_lastname' },            
            { header: this.translate.instant('Cf_FirstName'), field: 'us_firstname' },
            { header: this.translate.instant('Cf_Uemail'), field: 'us_email' },
        ];
        this.activeList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Cf_InAct'), value: 0 },
            { label: this.translate.instant('Cf_Active'), value: 1 },
        ];      
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        this.dataList = [];
        this.groupListBase = [];
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readUsersData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.dataList = wRes.data.getUserList.UserList.map((item, index) => {
            item.name = item.us_login;
            item.label = item.us_login;
            item._label = item.us_login;
            item.us_firstname = getField(item.us_firstname);
            item.us_lastname = getField(item.us_lastname);
            item.us_email = getField(item.us_email);
            item.id = index + 1;
            return item;
        });
        this.getUserListDelegate();
        this.groupListBase = getGroupListData(wRes.data.getGroupList.GroupList);
    }

    private readUsersData() {
        return forkJoin([
            this.api.execUrlAction('getalluserlist', ''),
            this.api.execUrlAction('getgrouplist', ''),]).pipe(
            map(([getUserList, getGroupList,]) => {
                return { getUserList, getGroupList };
            })
        );
    }

    private getUserListDelegate() {
        let wName = '';
        this.userListDelegate = [];
        this.dataList.forEach(item => {
            if (item.us_usertype === 0) {
                wName = getUserName(item, 'us_firstname', 'us_lastname', 'us_login');
                this.userListDelegate.push({
                    label: wName,
                    value: item.us_login,
                });
            }
        })
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        if (event.duplicate === true) {
            this.addToDataList(event);
        } else {
            this.dataList = this.dataList.map((item, index) => {
                if (item.us_login === event.data.data.login) {
                    item.label = event.data.data.login;
                    item.name = event.data.data.login;
                    item.us_active = + event.data.data.active;
                    item.us_autogenerated = + event.data.data.autogenerated;
                    item.us_email = event.data.data.email;
                    item.us_firstname = event.data.data.firstname;
                    item.us_lastname = event.data.data.lastname;
                    item.us_usertype = event.data.data.usertype;
                    item._label = event.data.data.login;
                    return item;
                } else {
                    return item;
                }
            });
        }
        this.closeTab(event);
    }

    addTab(event) {
        this.addToDataList(event);
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    private addToDataList(event) {
        this.dataList.push({
            label: event.data.data.login,
            name: event.data.data.login,
            us_active: + event.data.data.active,
            us_autogenerated: + event.data.data.autogenerated,
            us_email: event.data.data.email,
            us_firstname: event.data.data.firstname,
            us_lastname: event.data.data.lastname,
            us_login: event.data.data.login,
            us_usertype: event.data.data.usertype
        })
        this.dataList = this.dataList.map((item, index) => {
            item._label = item.name;
            item.id = index + 1;
            return item;
        });        
    }

    deleteTab(event) {
        this.dataList = this.dataList.filter((item) => {
            return item.name !== event.data.login;
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelU', {label: event.data.login}),
            () => {
                this.delete(event);
            }
        );
    }
    
    public async delete(event) {
        let wRes: any;
        const wdata = { user: event.data.login };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deleteuser', wdata ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    public clickcolDup(event, aData) {
        if (!this.isAlreadySelected(aData.id)) {
            this.duplicate = true;
        }
    }

    public onLoadItem(event) {
        this.duplicate = false;
    }

    sortReference(event: any): void {}
}
